import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import commonMessages from 'components/layout/Footer/FooterView/messages'
import s from './FooterBottomSection.scss'


// TODO if we need this?
// const siteLockVerify = () => {
//   window.open(
//     'https://www.sitelock.com/verify.php?site=scentbird.com',
//     'SiteLock',
//     'width=600,height=600,left=160,top=170'
//   )
//   return false
// }

const year = new Date().getFullYear()

const FooterBottomSection = ({ isAddressVisible, isNavVisible }) => (
  <div className={s.footerBottomSection}>
    <div className={s.copyrights}>
      <FormattedMessage {...commonMessages.copyrights} values={{ year }} />
      {
        isAddressVisible && (
          <span itemScope itemType="http://schema.org/LocalBusiness">
            <span itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
              &nbsp;<span itemProp="streetAddress">10 W 33rd St Rm 1011</span>
              &nbsp;<span itemProp="addressLocality">New York</span>,
              &nbsp;<span itemProp="addressRegion">NY</span>
              &nbsp;<span itemProp="postalCode">10001-3317</span>
            </span>
          </span>
        )
      }
    </div>
    {
      isNavVisible && (
        <div className={s.nav}>
          <Link className={s.navItem} customColor toOLD="/privacy" title={commonMessages.privacyPolicy} />
          <Link className={s.navItem} customColor toOLD="/terms" title={commonMessages.termsAndConditions} />
        </div>
      )
    }
  </div>
)

FooterBottomSection.propTypes = {
  isAddressVisible: PropTypes.bool,
  isNavVisible: PropTypes.bool,
}

FooterBottomSection.defaultProps = {
  isAddressVisible: false,
  isNavVisible: true,
}


export default FooterBottomSection
